export default "__VITE_ASSET__DJZ9skIK__"